import React, { useEffect, useRef, useState } from 'react'
import countries from '../../../constents/countries';
import { InputBoxWraper } from '../../../constents/components';
import useSendMobileOtp from '../../../Hooks/MobileOtp/useSendMobileOtp';
import useMobileOtpVerify from '../../../Hooks/MobileOtp/useOtpMobileVerify';
import { CITY_LIST } from "../../../constants/list";
const stateData = () => ([
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand",
    "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
    "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab",
    "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura",
    "Uttar Pradesh", "Uttarakhand", "West Bengal",
    "Andaman and Nicobar Islands", "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu",
    "Lakshadweep", "Delhi", "Puducherry", "Jammu and Kashmir", "Ladakh"
]);


const MobileNumberVerification = ({
    handleInputChange,
    updateState,
    updateCity,
    details = {},
    email,
    updateCountry,
    updateMobile,
    errors = {},
    isMobileNumberVerified,
    setIsMobileNumberVerified,
    mobile,
    flag
}) => {
    const intervalId = useRef();

    const [selectedCountry, setSelectedCountry] = useState(countries[0])
    const [mobileNumber, setMobileNumber] = useState(mobile || '');

    const [isCityDropdownOpen, setIsCityDropdownOpen] = useState(false);
    const [cityValue, setCityValue] = useState(details?.city || '');

    const [isOtpSendSucess, setIsOtpSendSucess] = useState(false);
    const [otp, setOtp] = useState('');
    const [resendOtpTimer, setResendOtpTimer] = useState(60);
    const [numbersOfResendOtpAttempts, setNumberOfResenOtpAttempts] = useState(0);

    // const [sendOtpLoading, sendOtpError, sendOtpFunction] = useSendMobileOtp({ onSucess: () => { setNumberOfResenOtpAttempts(pre => pre + 1); setIsOtpSendSucess(true); setResendOtpTimer(60) } })
    // const [verifyOtpLoading, verifyOtpError, verifyOtpFunction] = useMobileOtpVerify({ onSucess: () => { setIsMobileNumberVerified(true) } });
    useEffect(() => {
        if (mobileNumber) {
            setIsMobileNumberVerified(true);
        }
    }, [mobileNumber, setIsMobileNumberVerified]);

    useEffect(() => {
        setCityValue(details?.city || '');
    }, [details.city]);

    useEffect(() => {
        if (numbersOfResendOtpAttempts > 0) {
            intervalId.current = setInterval(() => {
                setResendOtpTimer((pre) => pre - 1);


            }, 1000);
        }

        return () => clearInterval(intervalId.current);
    }, [numbersOfResendOtpAttempts])


    useEffect(() => {
        if (resendOtpTimer <= 1) {
            setResendOtpTimer(0);
            clearInterval(intervalId.current);
        }
    }, [resendOtpTimer])

    const verifyOtpfnArg = {
        "otp": otp,
        "email": email,
        "mobile": mobileNumber,
        "countryCode": selectedCountry.mobile_code,
        "country": selectedCountry.iso_code,
    }

    const sendOtpfnArg = {
        "mobile": mobileNumber,
        "countryCode": selectedCountry.mobile_code,
        "email": email,
    }

    const filteredCities = CITY_LIST.filter((city) =>
        city.toLowerCase().includes((details?.city || '').toLowerCase())
    );
    return (
        <div className=' py-4'>

            {/* number */}
            <div className=' flex gap-2 flex-col'>
                <InputBoxWraper>
                    <select
                        onChange={(e) => { e.preventDefault(); setSelectedCountry(countries[e.target.value]); updateCountry(countries[e.target.value].country); }}
                        className=' outline-none border-none w-full'>
                        {countries.map((item, index) => (
                            <option
                                value={index} key={index} className='flex items-center gap-4'>
                                <p>{item.country + " "}</p><span className='font-semibold text-xl py-x'>{" (" + item.mobile_code + ")"}</span>
                            </option>
                        ))}
                    </select>
                </InputBoxWraper>


                {flag && (
                    <div>
                        <InputBoxWraper>
                            <select
                                className="bg-transparent outline-none border-none w-full"
                                value={details?.location || ""}
                                onChange={(e) =>
                                    handleInputChange(
                                        updateState,
                                        e.target.value,
                                        "location"
                                    )
                                }
                            >
                                <option value="">Enter a state</option>

                                {stateData().map((state) => (
                                    <option key={state} value={state}>
                                        {state}
                                    </option>
                                ))}
                            </select>
                        </InputBoxWraper>

                        {errors.location && (
                            <p className="text-sm text-red-500 mt-1">
                                {errors.location}
                            </p>
                        )}
                    </div>
                )}

                {flag && (
                    <div className="relative">
                        <InputBoxWraper>
                            <input
                                type="text"
                                className="bg-transparent outline-none border-none w-full"
                                placeholder="Enter city"
                                value={cityValue}
                                onFocus={() => setIsCityDropdownOpen(true)}
                                onChange={(e) => {
                                    const value = e.target.value;

                                    setCityValue(value);

                                    if (value.trim()) {
                                        handleInputChange(
                                            updateCity,
                                            value,
                                            "city"
                                        );
                                    }

                                    setIsCityDropdownOpen(true);
                                }}
                            />

                            <button
                                type="button"
                                onMouseDown={(e) => {
                                    e.preventDefault();
                                    setIsCityDropdownOpen(prev => !prev);
                                }}
                                className="flex items-center justify-center"
                            >
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                >
                                    <path
                                        d="M7 10L12 15L17 10"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </button>
                        </InputBoxWraper>

                        {isCityDropdownOpen && (
                            <div className="absolute left-0 right-0 top-full z-50 mt-1 max-h-60 overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-lg">
                                {CITY_LIST
                                    .filter((city) =>
                                        city
                                            .toLowerCase()
                                            .includes(cityValue.toLowerCase())
                                    )
                                    .map((city) => (
                                        <button
                                            key={city}
                                            type="button"
                                            className="block w-full px-4 py-2 text-left hover:bg-gray-100"
                                            onMouseDown={(e) => {
                                                e.preventDefault();
                                                setCityValue(city);
                                                updateCity(city);

                                                handleInputChange(
                                                    updateCity,
                                                    city,
                                                    "city"
                                                );

                                                setIsCityDropdownOpen(false);
                                            }}
                                        >
                                            {city}
                                        </button>
                                    ))}
                            </div>
                        )}

                        {errors.city && (
                            <p className="text-sm text-red-500 mt-1">
                                {errors.city}
                            </p>
                        )}
                    </div>
                )}


                {/* {
                    isMobileNumberVerified ?
                        (<InputBoxWraper classnames={' flex items-center'}>
                            <p className=' font-semibold'>{mobile ? mobile : mobileNumber}</p>
                        </InputBoxWraper>)
                        :
                        (<>
                            <InputBoxWraper>
                                <input
                                    value={mobileNumber}
                                    onChange={(e) => setMobileNumber(e.target.value)}
                                    type="number"
                                    name=""
                                    id=""
                                    className=' outline-none border-none w-full'
                                    onWheel={(e) => { e.target.blur() }}
                                    placeholder='Enter mobile number'
                                />
                            </InputBoxWraper>
                            <div className="flex items-center justify-center gap-2">
                                {numbersOfResendOtpAttempts > 0 ? (
                                    <>
                                        {resendOtpTimer > 1 && (
                                            <button
                                                className="text-sm bg-red-100 text-red-600 py-1 px-4 rounded cursor-not-allowed"
                                                disabled
                                            >
                                                00:{resendOtpTimer}
                                            </button>
                                        )}

                                        <button
                                            onClick={() => resendOtpTimer < 1 && sendOtpFunction(sendOtpfnArg)}
                                            className={`text-sm py-1 px-4 rounded transition 
                                       ${resendOtpTimer > 1
                                                    ? 'bg-red-100 text-red-400 cursor-not-allowed'
                                                    : 'bg-red-600 text-white cursor-pointer hover:bg-red-700'
                                                }`}
                                            disabled={resendOtpTimer > 1}
                                        >
                                            Resend OTP
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        {mobileNumber.toString().length >= 10 && (
                                            <button
                                                onClick={() => sendOtpFunction(sendOtpfnArg)}
                                                className="text-sm bg-red-600 text-white py-1 px-4 rounded cursor-pointer hover:bg-red-700"
                                            >
                                                Send OTP
                                            </button>
                                        )}
                                    </>
                                )}
                            </div>

                            {sendOtpError && (<p className=' text-red-900'>{sendOtpError}</p>)}
                        </>
                        )
                } */}

                <InputBoxWraper>
                    <input
                        value={mobileNumber}
                        onChange={(e) => {
                            const value = e.target.value;

                            setMobileNumber(value);
                            updateMobile(value);
                            setIsMobileNumberVerified(true);
                        }}
                        type="number"
                        className="outline-none border-none w-full"
                        onWheel={(e) => e.target.blur()}
                        placeholder="Enter mobile number"
                    />
                </InputBoxWraper>


                {/* {!isMobileNumberVerified && isOtpSendSucess &&
                    <>
                        <InputBoxWraper>
                            <input
                                value={otp}
                                onChange={(e) => setOtp(e.target.value)}
                                type="number"
                                name=""
                                id=""
                                className=' outline-none border-none w-full'
                                onWheel={(e) => { e.target.blur() }}
                            />
                        </InputBoxWraper>
                        <div className=' flex justify-center items-center'>

                            <p
                                onClick={() => verifyOtpFunction(verifyOtpfnArg)}
                                className={`text-sm py-1 px-4 rounded-lg bg-red-600 text-white cursor-pointer hover:bg-red-700 transition `} >Verify OTP</p>
                        </div>

                        {verifyOtpError && (<p className=' text-red-900'>{verifyOtpError}</p>)}
                    </>
                } */}
            </div>
        </div>
    )
}

export default MobileNumberVerification;
